import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { safeLazy } from '@/common/utils/import';

const { ESHealthInsurancePlanPage } = safeLazy(
  () =>
    import(
      '@/web/containers/Dashboard/ESWalletDashboard/containers/Home/ESWalletDashboardHome/components/ESHealthInsurancePlanPage/ESHealthInsurancePlanPage'
    )
);

export default function ESHealthInsurancePlanRootPage() {
  return (
    <RouterSuspense>
      <ESHealthInsurancePlanPage />
    </RouterSuspense>
  );
}
